import request from '@/api/request'
// 获取学时详情页数据
export function selectRelateAddressApi(){
    let url = '/api/manager/scheduling-address/list';

    let data = {
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}


